import {auth} from "../firebase"

export const sendEmailVerification = () => {
    return auth.currentUser.sendEmailVerification();
}

export const isUserVerified = () => {
    return auth?.currentUser?.emailVerified;
}


export const passwordPolicyRegex =
    //Minimum eight characters, at least one uppercase letter,
    // one lowercase letter, one number and one special character
    () => (/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?.:&])[A-Za-z\d@$!%*?.:&]{8,}$/)